eshopApp.controller('FullSearchController', ['$scope', '$http', function($scope, $http) {

	$scope.searchQuery = null;

	$scope.search = function() {

		$scope.spinner_products = true;
		$scope.spinner_categories = true;
		$scope.spinner_pages = true;

		$http.post('/a/search/products', {
			searchQuery: $scope.searchQuery,
		}).success(function(response){
			if (response.data) {
				$scope.products = response.data;
			}
		}).finally(function(){
			$scope.spinner_products = false;
		});

		$http.post('/a/search/categories', {
			searchQuery: $scope.searchQuery,
		}).success(function(response){
			if (response.data) {
				$scope.categories = response.data;
			}
		}).finally(function(){
			$scope.spinner_categories = false;
		});

		$http.post('/a/search/pages', {
			searchQuery: $scope.searchQuery,
		}).success(function(response){
			if (response.data) {
				$scope.pages = response.data;
			}
		}).finally(function(){
			$scope.spinner_pages = false;
		});
	}

	// Init
	$scope.$watch('searchQuery', function() {
		$scope.search();
	});
	
}]);